import styled, { css } from 'styled-components';
import type { ToneName } from '@/theme';

export type BadgeTone = ToneName | 'neutral';

const toneStyles = (tone: BadgeTone) =>
  tone === 'neutral'
    ? css`
        background: ${({ theme }) => theme.surface.elev};
        border-color: ${({ theme }) => theme.line.line};
        color: ${({ theme }) => theme.ink[2]};
      `
    : css`
        background: ${({ theme }) => theme.tone[tone].tint};
        border-color: ${({ theme }) => theme.tone[tone].soft};
        color: ${({ theme }) => theme.tone[tone].ink};
      `;

export const Badge = styled.span<{ $tone?: BadgeTone }>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  font-family: ${({ theme }) => theme.typography.fontFamilies.mono};
  font-size: ${({ theme }) => theme.typography.fontSizes.monoSm};
  letter-spacing: ${({ theme }) => theme.typography.letterSpacings.wide};
  padding: ${({ theme }) => `${theme.spacing[1]} ${theme.spacing[3]}`};
  border-radius: ${({ theme }) => theme.radii.pill};
  border: 1px solid;
  white-space: nowrap;
  ${({ $tone = 'neutral' }) => toneStyles($tone)}
`;

export const BadgeDot = styled.span<{ $tone?: ToneName }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ theme, $tone = 'halo' }) => theme.tone[$tone].base};
`;
